import styled from 'styled-components';
import {MultiSelect as MantineMultiSelect} from '@mantine/core';

interface ContainerProps {
  gridColumn?: number;
  focus: boolean;
  border?: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 10px 15px;
  border-radius: 6px;
  background-color: white;
  cursor: pointer;
  grid-column: ${({gridColumn}) => `span ${gridColumn ?? 12}`};
  ${(props) => props.border && 'border: 1px solid rgba(128, 128, 128, 0.6);'};

  .mantine-MultiSelect-inputField::placeholder {
    color: rgba(0, 0, 0, 0.3);
    font-weight: 600;
  }
`;

export const Label = styled.label`
  font-weight: 600;
  color: ${(props) => props.theme.colors.text};
  cursor: pointer;
`;

export const StyledMultiSelect = styled(MantineMultiSelect).attrs((props) => ({
  styles: {
    root: {width: '100%'},
    wrapper: {minHeight: 30},
    rightSection: {display: 'none'},
    selected: {
      backgroundColor: props.theme.colors.primaryLight,
      color: props.theme.colors.primary,
    },
    values: {width: '100%'},
    input: {
      padding: 0,
      outline: 'none',
      border: 'none',
      color: 'black',
      fontWeight: 600,
    },
  },
  classNames: {input: 'input'},
}))``;
